// ----------------------------------------------------------------------
// <copyright file="Izenda.Metrics.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var Panel = require('./Izenda.Panel');
  var classnames = require('classnames');
  var Button = require('./Izenda.Button');
  var localizer = require('share/localization/Izenda.Localizer');
  var { omit } = require('lodash/fp');

  var propsType = {
    dataSource: React.PropTypes.array.required,
    itemComponent: React.PropTypes.element.required,
    onAddMetric: React.PropTypes.func,
    onDeleteMetric: React.PropTypes.func,
    maximumMetrics: React.PropTypes.number,
    canAdd: React.PropTypes.bool,
    canDelete: React.PropTypes.bool,
    isExpanded: React.PropTypes.bool
  };

  var Metrics = React.createClass({
    propsType: propsType,

    getDefaultProps: function() {
      return {
        dataSource: [],
        isExpanded: true,
        canAdd: true,
        canDelete: true
      };
    },

    createMetric: function(item, index) {
      var handleDelete = function() {
        var props = this.props;
        props.onDeleteMetric && props.onDeleteMetric(index);
      }.bind(this);

      var headerComponent = function(props) {
        var classes = classnames('pull-right', { 'disabled-elm': !this.props.canDelete });
        var hint = props.isExpanded
          ? localizer.getText('COMMON_LABEL_COLLAPSE')
          : localizer.getText('COMMON_LABEL_EXPAND');
        return (
          <div className='left-header-metric'>
            <div className='inline-block' onClick={props.collapseToggle}>
              <i title={hint} className='icon-toggle' />
              <span className='panel-title'>{[localizer.getText('COMMON_LABEL_METRIC'), index + 1].join(' ')}</span>
            </div>
            <a title={localizer.getText('COMMON_LABEL_DELETE')} className={classes} onClick={handleDelete}>
              <span className='icon-cancel' />
            </a>
          </div>
        );
      }.bind(this);

      var header = {
        component: headerComponent
      };

      var props = this.props;
      var itemProps = omit(Object.keys(propsType), props);
      return (
        <Panel key={index} header={header} collapsible={true} initState={props.isExpanded}>
          <props.itemComponent {...itemProps} value={item} index={index} />
        </Panel>
      );
    },

    render: function() {
      var props = this.props;
      var dataSource = props.dataSource;
      var classes = classnames('metrics', props.className);

      var handleAddMetric = function() {
        if (!props.canAdd) return;
        if (props.maximumMetrics) {
          dataSource.length < props.maximumMetrics && props.onAddMetric && props.onAddMetric();
          return;
        }
        props.onAddMetric && props.onAddMetric();
      }.bind(this);

      var isAddButtonDisabled = !props.canAdd || dataSource.length >= props.maximumMetrics;
      return (
        <div className={classes}>
          {dataSource.map(this.createMetric)}
          <div className='metrics-footer'>
            <Button
              disabled={isAddButtonDisabled}
              className='pull-right'
              label={localizer.getText('COMPONENT_CONTROL_LABEL_ADD_METRIC')}
              onClick={handleAddMetric}
            />
          </div>
        </div>
      );
    }
  });

  module.exports = Metrics;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Metrics.jsx